module.exports = "/packs/she_chan_celebrate-48bf55bbfac6c4a5903111f1042a0f4d.svg";